module.exports = __webpack_public_path__ + "assets/img/project-autonomous-vehicle-thumb.ac9815cc.jpg";